module.exports = __webpack_public_path__ + "static/media/67.89fbae7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/67.jpg
// module id = 1006
// module chunks = 0